import React from 'react'
import './portfolio.css'
import IMG1 from '../../assets/Site1.jpg'
import IMG2 from '../../assets/Site2.jpg'
import IMG3 from '../../assets/Site3.jpg'
import IMG4 from '../../assets/Site4.jpg'
import IMG5 from '../../assets/Site5.jpg'
import IMG6 from '../../assets/Site6.jpg'
import IMG7 from '../../assets/Site7.jpg'
import IMG8 from '../../assets/Site8.jpg'
import IMG9 from '../../assets/Site9.jpg'

//DO NOT USE THE IMAGES IN PRODUCTION

const data = [
  {
    id: 1,
    image: IMG1,
    title: 'Fire (Fire is a food processing company)',
    github: 'https://github.com',
    demo: 'https://ets-fine.onrender.com'
  },
 {
    id: 2,
    image: IMG2,
    title: 'KATIFOODS (KatiFoods is an agri-food processing company)',
    github: 'https://github.com',
    demo: 'https://katifood.onrender.com/'
  },
 {
    id: 3,
    image: IMG3,
    title: 'SPAV (Animal and Plant Production Company)',
    github: 'https://github.com',
    demo: 'https://spav.onrender.com/',
  },
 {
    id: 4,
    image: IMG4,
    title: 'TANA PRESTIGE (MORE THAN JUST CLEAN - WE BUILD CONFIDENCE!)',
    github: 'https://github.com',
    demo: 'https://tanaprestige.lovable.app/'
  },
  {
    id: 5,
    image: IMG5,
    title: 'DST FOODS (Dst Foods is an agri-food processing agency for all categories of people)',
    github: 'https://github.com',
    demo: 'https://ozstream.tv/'
  },
  {
    id: 6,
    image: IMG6,
    title: 'FRUZAM (FRUZAM food processing company)',
    github: 'https://github.com',
    demo: 'https://fruzam.onrender.com/'
  },
  {
    id: 7,
    image: IMG7,
    title: 'DOUMA (Gives you healthy, fresh, spotless skin)',
    github: 'https://github.com',
    demo: 'https://soplarhu.onrender.com/'
  },
  {
    id: 8,
    image: IMG8,
    title: 'RUSSIA AND OPPORTUNITY (The Annual Marketing Conference)',
    github: 'https://github.com',
    demo: 'https://russia-opportunity-21.onrender.com/'
  },
  {
    id: 9,
    image: IMG9,
    title: 'Fine Biscuits on a mission to regain the local market)',
    github: 'https://github.com',
    demo: 'https://fine-biscuit.onrender.com/'
  }
]

const Portfolio = () => {
  return (
    <section id='portfolio'>
      <h5>My Recent Work</h5>
      <h2>Portfolio</h2>

      <div className="container portfolio__container">
        {
          data.map(({id, image, title, github, demo}) => {
            return (
              <article key={id} className='portfolio__item'>
                <div className='portfolio__item-image'>
                  <img src={image} alt={title} />
                </div>
                <h3>{title}</h3>
                <div className="portfolio__item-cta">
                  <a href={github} className='btn' target='_blank'>Github</a>
                  <a href={demo} className='btn btn-primary' target='_blank'>Live demo</a>
                </div>
              </article>
            )
          })
        }
      </div>
    </section>
  )
}

export default Portfolio